var $fc088db6dd370743$exports = {};
$fc088db6dd370743$exports = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};


export {$fc088db6dd370743$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
